(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommandations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;

            var slickOptionsRecommend = {
                centerMode: false,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: false,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            };

            // Init slider
            var sliderRecommend = $('.recommended-slider').slick(slickOptionsRecommend);
            let isSliding = false;

            $('.recommended-slider-control.prev-btn').on('click', function () {   
                if (isSliding) {
                    return;
                }

                sliderRecommend.slick('prev');                
            });

            $('.recommended-slider-control.next-btn').on('click', function () {
                if (isSliding) {
                    return;
                }

                sliderRecommend.slick('next');
            });

            sliderRecommend.on('swipe', function (event, slick, direction) {
                if (isSliding) {
                    return;
                }

                if (direction == 'left') {
                    sliderRecommend.slick('next');
                } else {
                    sliderRecommend.slick('prev');
                }
            });

            sliderRecommend.on('beforeChange', function () {
                isSliding = true;
            });

            sliderRecommend.on('afterChange', function (event, slick, currentSlide) {
                isSliding = false;
                setRecommendSliderDotActive(currentSlide);
            });    
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRecommendationsSection);

function setRecommendSliderDotActive(goToIndex) {
    const active_index = parseInt($('.recommended-slider-dot.active').data('slide-index'));
    $('.recommended-slider-dot').eq(active_index).removeClass('active');
    $('.recommended-slider-dot').eq(goToIndex).addClass('active');    
}

  } catch(e) { console.error(e); }
})();
})();
